import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { SERVICE_TYPES } from '../../../../../helper/types';
import '../../../../../assets/styles/Services.css';

function Header({setActiveSection}) {

  const next = () => {
    setActiveSection(SERVICE_TYPES.HOME_REPAIR);
  };

  const back = () => {
    setActiveSection(SERVICE_TYPES.ONLINE_ASSISTANCE);
  };

  return (
    <div className="servicios-container" style={{ marginTop: '10px', width: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={6} container justifyContent="flex-start">
              <Typography sx={{ marginLeft: '100px', fontSize: '30px' }}>Revisión y Puesta a Punto</Typography>
            </Grid>
            <Grid item xs={3} container alignItems="center" justifyContent="flex-end">
              <Button onClick={back} sx={{ mr: '100px', textTransform: 'none', margin: '0px', color: 'black' }}>←Asistencia Online y Telefónica</Button>
            </Grid>
            <Grid item xs={3} container alignItems="center" justifyContent="flex-end">
              <Button onClick={next} sx={{ mr: '100px', textTransform: 'none', color: 'black' }}>Reparación a Domicilio→</Button>
            </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Header;
